import { Box, ThemedDialog, CustomCard, CustomButton } from "ui-components";
import { useAtom } from "klyva";
import {
  pricingDialogState,
  closePricingDialog,
} from "ui-io/stores/pricing-store";
import { Button, Colors, DialogBody, Icon } from "@blueprintjs/core";
import { styled } from "styled-components";

const dialogStyle = {
  width: "unset",
  maxWidth: "1200px",
  borderRadius: "10px",
} as const;

const PricingPage = () => {
  const [dialogState] = useAtom(pricingDialogState);
  const { isOpen } = dialogState;
  if (!isOpen) return null;
  const planArray = [
    {
      icon: "/images/freemium.svg",
      for: "For Individuals",
      header: "Freemium",
      description: "Lorem Ipsum is simply dummy text of the printing and",
      currency: "£",
      price: "0",
      subscriptionFor: "annually",
      labels: [
        "All analytics features",
        "Up to 250,000 tracked visits",
        "Normal support",
        "Up to 3 team members",
      ],
    },

    {
      icon: "/images/preemium.svg",
      for: "For Startups",
      header: "Premium",
      description:
        "Unlock all functionalities with our Premium plan suitable for all.",
      currency: "£",
      price: "4799",
      subscriptionFor: "annually",
      labels: [
        "All analytics features",
        "All interactive features",
        "Advanced search options",
        "Full view of information",
        "Up to 250,000 companies",
      ],
    },
    {
      icon: "/images/enterprise.svg",
      for: "For Big companies",
      header: "Enterprise",
      description:
        "Unlock all functionalities with our Premium plan suitable for all.",
      currency: "",
      price: "Contact us",
      subscriptionFor: "",
      labels: [
        "All analytics features",
        "Up to 5,000,000 tracked visits",
        "Dedicated support",
        "Up to 50 team members",
      ],
    },
  ];

  return (
    <ThemedDialog
      isOpen={isOpen}
      onClose={closePricingDialog}
      style={dialogStyle}
    >
      <DialogBody style={{ maxHeight: "unset" }}>
        <div className="float-right cursor-pointer">
          <Icon icon="cross" size={20} onClick={closePricingDialog} />
        </div>
        <Box width="1" height="1" mt="medium" p={"medium"}>
          <Box
            maxWidth={"1/2"}
            className="text-center"
            justify="center"
            flexDir="col"
            m={"auto"}
            mt={"large"}
            mb={"large"}
          >
            <div className="fs-32 mb-lg fw-bold">
              Simple, transparent pricing
            </div>
            <div className="fs-12">
              Unlock all functionalities and view all types of companies
              including full data with our Premium plan suitable for all.
            </div>
            <div className="fs-14 fw-bold mt-md">PRICING</div>
          </Box>
          <Box flexDir="row" justify="between" mb="large" items="end">
            {planArray.map((item,index) => (
              <Box m={"medium"} key={index}>
                <CustomCard maxWidth="280px" minHeight="400px">
                  <Box flexDir="row" items="center">
                    <ImageContainer items="center">
                      <img src={item.icon} className="m-auto" width={30} />
                    </ImageContainer>
                    <div className="mb-lg mt-lg ml-sm">
                      <div className="fs-13">{item.for}</div>
                      <div className={"fw-bold fs-20"}>{item.header}</div>
                    </div>
                  </Box>
                  <div className="fs-13">{item.description}</div>
                  <div className="display-flex mt-lg mb-lg">
                    <div className={"fw-bold fs-24"}>
                      {item.currency}
                      {item.price}
                    </div>
                    <div className="fs-13">
                      {item.subscriptionFor && `/${item.subscriptionFor}`}
                    </div>
                  </div>
                  <div className="fs-13">What's Included</div>
                  {item.labels.map((label, idx) => (
                    <div className="display-flex mt-sm mb-sm" key={idx}>
                      <CheckedIcon />
                      {label}
                    </div>
                  ))}
                  <CustomButton width="100%" bradius="15px" pd="5px 15px" className={"mt-md br-md mb-xlg"} disabled = {index == 0} >{index == 0 ? "Current Plan": "Get Started"}</CustomButton>
                </CustomCard>
              </Box>
            ))}
          </Box>
        </Box>
      </DialogBody>
    </ThemedDialog>
  );
};
export default PricingPage;

const ImageContainer = styled(Box)`
  background-color: #ecebff;
  height: 50px;
  width: 50px;
  border-radius: 15px;
`;
const CheckedIcon = styled.div`
  width: 16px;
  height: 16px;
  margin-right: 5px;
  background-color: ${({ theme: { darkMode } }) =>
    darkMode ? Colors.GRAY1 : Colors.DARK_GRAY5};
  border-radius: 50%;
  position: relative;
  &::before {
    content: "";
    width: 10px;
    height: 5px;
    border: 1.5px solid white;
    border-top: none;
    border-right: none;
    transform: rotate(-45deg);
    position: absolute;
    top: 25%;
    left: 25%;
  }
`;